import React, { useState, useEffect, useRef } from 'react';
import { Modal, Radio } from 'antd';
import useState2RM from '../../hooks/useState2ReduxMock';
import styles from './WmFolderSortModal.module.scss';
import { ModalCloseSmall } from '@web-common/components/UI/Icons/icons';
import { getMailFolderIcon } from '@web-mail/components/ColumnMailBox/FolderTree';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import { useAppDispatch } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { getIn18Text } from 'api';
import classnames from 'classnames';
import pinyin from 'tiny-pinyin';
import { FLOLDER } from '../../../../api/src/api/logical/mail';
const RegE = /[a-zA-Z]/;
const RegChi = /[\u4E00-\u9FFF]/;
const RegNum = /[0-9]/;
const WmFolderSortModal = () => {
    var _a, _b, _c;
    const [sortWay, setSortWay] = useState('az');
    const [sysFolders, setSysFolders] = useState([]);
    const [customFolders, setCustomFolders] = useState([]);
    const folderAreaRef = useRef(null);
    const [folderSortModalData, setFolderSortModalData] = useState2RM('folderSortModalData', 'doUpdateFolderSortModalData');
    const [folderSortModalVisiable, setFolderSortModalVisiable] = useState2RM('folderSortModalVisiable', 'doUpdateFolderSortModalVisiable');
    const dispatch = useAppDispatch();
    const getWeight = (char) => {
        if (RegE.test(char))
            return 1;
        if (RegNum.test(char))
            return 2;
        return 3;
    };
    const compareChar = (a, b, index) => {
        let charA = a.charAt(index);
        let charB = b.charAt(index);
        if (charA !== '' && charB === '')
            return 1;
        if (charA === '' && charB !== '')
            return -1;
        if (charA === '' && charB === '')
            return 0;
        if (charA === charB)
            return compareChar(a, b, index + 1);
        let weightA = getWeight(charA);
        let weightB = getWeight(charB);
        if (weightA > weightB)
            return 1;
        if (weightA < weightB)
            return -1;
        const weight = weightA;
        if (weight === 1) {
            return charA > charB ? 1 : -1;
        }
        if (weight === 2) {
            return charA > charB ? 1 : -1;
        }
        if (weight === 3)
            return 0;
        return 0;
    };
    const compareStr = (a, b) => {
        let strA = a.toLocaleLowerCase();
        let strB = b.toLocaleLowerCase();
        try {
            if (RegChi.test(strA)) {
                strA = pinyin.convertToPinyin(strA, '', true);
            }
            if (RegChi.test(strB)) {
                strB = pinyin.convertToPinyin(strB, '', true);
            }
            return compareChar(strA, strB, 0);
        }
        catch (error) {
            Message.error({ content: getIn18Text('PAIXUSHIBAI') });
            return 0;
        }
    };
    const changeSortWay = e => {
        const sortWay = e.target.value;
        setSortWay(sortWay);
        if (sortWay === 'az')
            sortCustom();
        if (sortWay === 'za')
            sortCustom(true);
    };
    const confirmSort = () => {
        const { parentId, accountId } = folderSortModalData;
        const sorts = [...(sysFolders || []).map(item => item.entry.mailBoxId), ...(customFolders || []).map(item => item.entry.mailBoxId)];
        dispatch(Thunks.sortUserFolder({ id: parentId, sorts, accountId }));
        setFolderSortModalVisiable(false);
    };
    const sortCustom = (reverse) => {
        const { folders } = folderSortModalData;
        let customFolders = folders.filter(item => {
            var _a;
            return ((_a = item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxType) !== 'sys';
        });
        customFolders.sort((a, b) => compareStr(a.entry.mailBoxName, b.entry.mailBoxName));
        if (reverse) {
            customFolders.reverse();
        }
        setCustomFolders(customFolders);
    };
    useEffect(() => {
        if (folderSortModalVisiable) {
            setSysFolders([]);
            setCustomFolders([]);
            setSortWay('az');
            const { folders } = folderSortModalData;
            let sysFolders = folders.filter(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxType) === 'sys'; });
            const topFolderId = [FLOLDER.DEFAULT, FLOLDER.UNREAD, FLOLDER.EDM_REPLY, FLOLDER.EDM_OTHER_REPLY, FLOLDER.SENT, FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW];
            const topFolder = [];
            const bottomFolder = [];
            topFolderId.forEach(item => {
                const res = sysFolders.find(folder => folder.entry.mailBoxId == item);
                if (res) {
                    topFolder.push(res);
                }
            });
            sysFolders.forEach(item => {
                let numberId = item.mailBoxId;
                try {
                    numberId = parseInt(numberId);
                }
                catch (e) {
                    console.error('[getWmGuideSortFoldeIds error]', e);
                }
                if (!topFolderId.includes(numberId)) {
                    bottomFolder.push(item);
                }
            });
            setSysFolders([...topFolder, ...bottomFolder]);
            sortCustom();
            setTimeout(() => {
                try {
                    if (folderAreaRef === null || folderAreaRef === void 0 ? void 0 : folderAreaRef.current) {
                        folderAreaRef.current.scrollTop = 0;
                    }
                }
                catch (error) {
                    console.log('setScrollTopError', error);
                }
            }, 0);
        }
    }, [folderSortModalVisiable]);
    return (React.createElement(Modal, { className: styles.folderSortModal, width: 480, title: getIn18Text('QINGXUANZEPAIXUGZ'), visible: folderSortModalVisiable, wrapClassName: styles.folderSortModalWrap, okText: getIn18Text('QUERENPAIXU'), maskClosable: true, cancelText: getIn18Text('QUXIAO'), closeIcon: React.createElement(ModalCloseSmall, { "data-test-id": "folder-sort-modal-close" }), onCancel: () => setFolderSortModalVisiable(false), onOk: () => confirmSort(), centered: true, okButtonProps: { 'data-test-id': 'folder-sort-modal-ok' } },
        React.createElement("div", { className: styles.sortArea },
            React.createElement("div", { className: styles.sortWays },
                React.createElement(Radio.Group, { onChange: changeSortWay, value: sortWay, "data-test-id": "folder-sort-modal-radio" },
                    React.createElement(Radio, { value: "az", className: styles.sortWay, "data-test-id": "folder-sort-modal-radio-az" }, getIn18Text('ANZIDINGYIWENJJSZMCA-ZPX')),
                    React.createElement(Radio, { value: "za", className: styles.sortWay, "data-test-id": "folder-sort-modal-radio-za" }, getIn18Text('ANZIDINGYIWENJJSZMCZ-APX')))),
            React.createElement("div", { className: styles.intro },
                getIn18Text('ZHUYI：ZIDONGPXGZJDZDYWJJYX，QMRAXTWJJZS，ZDYWJJZXDFSPL。RWJJSZWSZHFH，JPZZXF。'),
                React.createElement("span", { className: styles.red }, getIn18Text('QINGZIXICHAYUEXFSXYL，PXHWFCX。'))),
            React.createElement("div", { className: classnames(styles.folderArea, 'sirius-scroll'), ref: folderAreaRef }, (_a = (sysFolders || [])) === null || _a === void 0 ? void 0 :
                _a.map((item, index) => {
                    const { mailBoxName } = item.entry;
                    return (React.createElement("div", { key: item.entry.mailBoxId, className: `${styles.folder} ${index == 6 ? styles.bottomLine : ''}` },
                        React.createElement("span", { className: styles.folderIcon }, getMailFolderIcon(item.entry.mailBoxId)),
                        React.createElement("span", { className: styles.folderName }, mailBoxName)));
                }),
                ((_b = (sysFolders || [])) === null || _b === void 0 ? void 0 : _b.length) > 0 ? React.createElement("div", { className: styles.dividerLine }, getIn18Text('YISHANGXITONGWENJJSXBZXG')) : React.createElement(React.Fragment, null), (_c = (customFolders || [])) === null || _c === void 0 ? void 0 :
                _c.map(item => {
                    const { mailBoxName } = item.entry;
                    return (React.createElement("div", { key: item.entry.mailBoxId, className: styles.folder },
                        React.createElement("span", { className: styles.folderIcon }, getMailFolderIcon(item.entry.mailBoxId)),
                        React.createElement("span", { className: styles.folderName }, mailBoxName)));
                })))));
};
export default WmFolderSortModal;
